/* SellEton: add-on photo thumbnails for Globo option lists.
   Reads the carrier variant behind each Globo checkbox (gpo-data-product-handle /
   gpo-data-variant-id), takes that variant's image from /products/<handle>.js and
   shows it as a small thumbnail next to the item. Click the thumbnail to enlarge.
   No image on the variant = nothing shown (safe default). */
(function () {
  if (window.__seThumbs) return; window.__seThumbs = true;
  var cache = {};
  function getProduct(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function sized(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var css = '.se-thumb{width:52px;height:52px;flex:0 0 52px;object-fit:contain;background:#fff;border:1px solid #e3e3e3;border-radius:4px;margin-right:10px;cursor:zoom-in;vertical-align:middle}' +
    '.gpo-choicelist.se-has-thumb label{display:flex!important;align-items:center}' +
    '#se-thumb-zoom{position:fixed;inset:0;z-index:2147483646;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;cursor:zoom-out}' +
    '#se-thumb-zoom figure{background:#fff;padding:16px;border-radius:6px;max-width:min(92vw,560px);margin:0;text-align:center}' +
    '#se-thumb-zoom img{max-width:100%;max-height:70vh;object-fit:contain}' +
    '#se-thumb-zoom figcaption{font:14px/1.4 sans-serif;color:#222;margin-top:8px}' +
    '@media (max-width:600px){.se-thumb{width:44px;height:44px;flex-basis:44px;margin-right:8px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function zoom(src, caption) {
    var o = document.createElement('div'); o.id = 'se-thumb-zoom';
    var f = document.createElement('figure');
    var i = document.createElement('img'); i.src = sized(src, 800); i.alt = caption;
    var c = document.createElement('figcaption'); c.textContent = caption;
    f.appendChild(i); f.appendChild(c); o.appendChild(f);
    o.addEventListener('click', function () { o.remove(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { o.remove(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(o);
  }

  function decorate(inp) {
    if (inp.__seDone) return; inp.__seDone = true;
    var h = inp.getAttribute('gpo-data-product-handle'), vid = inp.getAttribute('gpo-data-variant-id');
    if (!h || !vid) return;
    getProduct(h).then(function (p) {
      if (!p) return;
      var v = (p.variants || []).find(function (x) { return String(x.id) === String(vid); });
      var src = v && v.featured_image && v.featured_image.src;
      if (!src) return;
      var row = inp.closest('.gpo-choicelist'); var label = row && row.querySelector('label');
      if (!label || label.querySelector('.se-thumb')) return;
      var img = document.createElement('img');
      img.className = 'se-thumb'; img.loading = 'lazy'; img.src = sized(src, 120);
      img.alt = v.featured_image.alt || inp.value;
      img.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); zoom(src, inp.value); });
      label.insertBefore(img, label.firstChild);
      row.classList.add('se-has-thumb');
    });
  }
  function scan(root) {
    (root || document).querySelectorAll('input[gpo-data-variant-id]').forEach(decorate);
  }
  scan();
  new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
})();
